import api from './api';

// PM analitik P6 — geçmiş dönem sonuçlarının Excel ile içe aktarılması. Uçlar backend PerformanceHistoryImportController'ın
// aynasıdır ([Route("v1/performance-history-import")], yalnız İK). Akış: şablon → doğrulama (önizleme, hiçbir şey yazmaz) →
// onay → kayıt. Kayıt dosyayı YENİDEN yükler (sunucu geçici dosya tutmaz) ve doğrulamayı baştan koşar.
const BASE = '/v1/performance-history-import';

export const getHistoryImportPeriods = (params) => api.get(`${BASE}/periods`, { params });

export const getHistoryImportTemplate = ({ resultKind, ratingScaleId } = {}) => api.get(`${BASE}/template`, {
  params: { ...(resultKind ? { resultKind } : {}), ...(ratingScaleId ? { ratingScaleId } : {}) },
  responseType: 'blob',
});

function formOf(file, meta) {
  const form = new FormData();
  form.append('file', file);
  Object.entries(meta || {}).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== '') form.append(k, v);
  });
  return form;
}

export const validateHistoryImport = (file, meta) => api.post(`${BASE}/validate`, formOf(file, meta), {
  headers: { 'Content-Type': 'multipart/form-data' },
});

export const executeHistoryImport = (file, meta) => api.post(`${BASE}/execute`, formOf(file, meta), {
  headers: { 'Content-Type': 'multipart/form-data' },
});

export const deleteHistoryImportPeriod = (periodId) => api.delete(`${BASE}/periods/${periodId}`);

export const getRatingScales = () => api.get('/v1/rating-scales');
